import { type WithReactChildren } from '../../utils/types/WithReactChildren'
import { type featureFlag } from './constants.featureFlags'
import { useFeatureFlag, type UseFeatureFlagParams } from './useFeatureFlag'

type FeatureFlagConfig = UseFeatureFlagParams['1']

export type RenderFeatureProps = {
  flag: featureFlag
} & FeatureFlagConfig

export function RenderFeature({
  children = null,
  flag,
  ...config
}: WithReactChildren<RenderFeatureProps>) {
  const { isEnabled } = useFeatureFlag(flag, config)

  if (isEnabled) return children

  return null
}
